import React, { useState } from "react";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";
import firebase, { FS } from "../../../services/firebase";

const CreateDemoReferral = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [result, setResult] = useState(null);

  const createDemoReferral = async () => {
    setIsLoading(true);
    setResult(null);

    try {
      // Generate random file name for upload
      const timestamp = moment().unix();
      const randomId = uuidv4();
      const fileName = `${timestamp}-${randomId}-TestReferral.pdf`;

      // 1. Upload file to GCP Cloud Storage
      const storageRef = firebase.storage.ref();
      const fileRef = storageRef.child(`ocr-referral/${fileName}`);

      // Create a simple demo PDF blob (minimal PDF content)
      const pdfContent = `%PDF-1.4
1 0 obj
<<
/Type /Catalog
/Pages 2 0 R
>>
endobj

2 0 obj
<<
/Type /Pages
/Kids [3 0 R]
/Count 1
>>
endobj

3 0 obj
<<
/Type /Page
/Parent 2 0 R
/MediaBox [0 0 612 792]
/Contents 4 0 R
>>
endobj

4 0 obj
<<
/Length 44
>>
stream
BT
/F1 12 Tf
72 720 Td
(Demo Referral PDF) Tj
ET
endstream
endobj

xref
0 5
0000000000 65535 f 
0000000009 00000 n 
0000000058 00000 n 
0000000115 00000 n 
0000000204 00000 n 
trailer
<<
/Size 5
/Root 1 0 R
>>
startxref
297
%%EOF`;

      const testFileBlob = new Blob([pdfContent], { type: "application/pdf" });
      await fileRef.put(testFileBlob);

      // 2. Create Firestore record with placeholder data
      // Generate random data
      const randomNames = [
        "John Smith",
        "Sarah Johnson",
        "Michael Brown",
        "Emily Davis",
        "David Wilson",
        "Lisa Anderson",
        "Robert Taylor",
        "Jennifer Martinez",
      ];
      const randomStreets = [
        "SKYRING STREET",
        "QUEEN STREET",
        "BUNDABERG ROAD",
        "BARGARA ROAD",
        "TAKALVAN STREET",
        "BOURBONG STREET",
      ];
      const randomSuburbs = [
        "BUNDABERG EAST QLD 4670",
        "BUNDABERG QLD 4670",
        "BARGARA QLD 4670",
        "TAKALVAN QLD 4670",
        "NORTH BUNDABERG QLD 4670",
      ];
      const randomSpecialties = [
        "General Practice",
        "Cardiology",
        "Dermatology",
        "Orthopedics",
        "Neurology",
        "Psychiatry",
        "Ophthalmology",
      ];
      const randomTitles = ["Mr", "Mrs", "Ms", "Dr"];
      const randomGenders = ["Male", "Female"];
      const randomLocations = [
        "Bundaberg Base Hospital",
        "Bargara Medical Centre",
        "Takalvan Medical Centre",
        "North Bundaberg Clinic",
      ];

      const randomName = randomNames[Math.floor(Math.random() * randomNames.length)];
      const randomStreet = randomStreets[Math.floor(Math.random() * randomStreets.length)];
      const randomSuburb = randomSuburbs[Math.floor(Math.random() * randomSuburbs.length)];
      const randomSpecialty = randomSpecialties[Math.floor(Math.random() * randomSpecialties.length)];
      const randomTitle = randomTitles[Math.floor(Math.random() * randomTitles.length)];
      const randomGender = randomGenders[Math.floor(Math.random() * randomGenders.length)];
      const randomLocation = randomLocations[Math.floor(Math.random() * randomLocations.length)];

      // Generate random phone numbers
      const randomPhone = `04${Math.floor(Math.random() * 90000000) + 10000000}`;

      // Generate random Medicare number
      const randomMedicare = `${Math.floor(Math.random() * 9000000000) + 1000000000}`;

      // Generate random DOB (between 18-80 years old)
      const currentYear = new Date().getFullYear();
      const randomYear = currentYear - Math.floor(Math.random() * 62) - 18;
      const randomMonth = Math.floor(Math.random() * 12) + 1;
      const randomDay = Math.floor(Math.random() * 28) + 1;
      const randomDOB = `${randomYear}-${randomMonth.toString().padStart(2, "0")}-${randomDay
        .toString()
        .padStart(2, "0")}`;

      // Generate random start date (within last 30 days)
      const randomStartDate = new Date();
      randomStartDate.setDate(randomStartDate.getDate() - Math.floor(Math.random() * 30));
      const formattedStartDate = randomStartDate.toISOString().split("T")[0];

      // Generate email safely (replace all spaces with dots)
      const emailName = randomName.toLowerCase().replace(/\s+/g, ".");

      // Generate referrer name safely (use last name or full name if only one word)
      const nameParts = randomName.split(" ");
      const referrerLastName = nameParts.length > 1 ? nameParts[nameParts.length - 1] : randomName;

      const demoReferralData = {
        ExternalId: "",
        address: `${Math.floor(Math.random() * 999) + 1}-${Math.floor(Math.random() * 999) + 1} ${randomStreet}`,
        caseManager: "",
        clientExisting: "",
        clientGroup: "",
        clientName: `${randomName} |`,
        clinic: {
          name: randomLocation,
          address: `${Math.floor(Math.random() * 999) + 1} ${randomStreet}`,
          phone: randomPhone,
        },
        dateOfBirth: randomDOB,
        dvaCardNumber: "",
        email: `${emailName}@example.com`,
        fileName: fileName,
        gender: randomGender,
        location: randomLocation,
        medicareCardIRN: Math.floor(Math.random() * 9) + 1,
        medicareCardNumber: randomMedicare,
        note1: "Demo referral created for testing purposes",
        note2: "This is a placeholder referral with random data",
        oriFileName: fileName,
        phoneNumberHome: randomPhone,
        phoneNumberMobile: randomPhone,
        referrerName: `Dr. ${referrerLastName}`,
        referrerProviderNumber: `${Math.floor(Math.random() * 900000000) + 100000000}`,
        specialityName: randomSpecialty,
        startDate: formattedStartDate,
        suburbStatePostalCode: randomSuburb,
        title: randomTitle,
      };

      // Save to Firestore
      await FS.setDoc(FS.doc(firebase.modularFirestore(), "ocr_clients", fileName), demoReferralData);

      setResult({
        success: true,
        message: "Demo referral created successfully!",
        data: {
          referralId: fileName,
          fileName: fileName,
        },
      });
    } catch (error) {
      console.error("Error creating demo referral:", error);

      let errorMessage = "An unexpected error occurred while creating the demo referral.";

      if (error.code === "storage/unauthorized") {
        errorMessage = "Storage access denied. Please check your permissions.";
      } else if (error.code === "storage/quota-exceeded") {
        errorMessage = "Storage quota exceeded. Please try again later.";
      } else if (error.code === "permission-denied") {
        errorMessage = "Firestore access denied. Please check your permissions.";
      } else if (error.message) {
        errorMessage = `Error: ${error.message}`;
      }

      setResult({
        success: false,
        message: errorMessage,
        error: error,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="section">
        <h1 className="title">Create Demo Referral</h1>
        <p className="subtitle">
          This will create a demo referral record in Firestore and upload the test PDF file to GCP Cloud Storage.
        </p>

        <div className="field">
          <div className="control">
            <button
              className={`button is-primary ${isLoading ? "is-loading" : ""}`}
              onClick={createDemoReferral}
              disabled={isLoading}
            >
              {isLoading ? "Creating Demo Referral..." : "Create Demo Referral"}
            </button>
          </div>
        </div>

        {result && (
          <div className={`notification ${result.success ? "is-success" : "is-danger"}`}>
            <button className="delete" onClick={() => setResult(null)}></button>
            <strong>{result.success ? "Success!" : "Error!"}</strong>
            <p>{result.message}</p>
            {result.success && result.data && (
              <div className="content">
                <p>
                  <strong>Referral ID:</strong> {result.data.referralId}
                </p>
                <p>
                  <strong>File Name:</strong> {result.data.fileName}
                </p>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default CreateDemoReferral;
